import { Animation } from './Animation'
import transcribingData from './data/transcribing.json'
import { LottieProps } from 'react-lottie-player'

const Transcribing = (props: LottieProps) => <Animation {...props} animationData={transcribingData} />

export default Transcribing
